/**
 * =============================================================================
 * recently-viewed.js
 * =============================================================================
 * Manage the recently viewed section
 * 
 * Stores product handles when viewing product pages, then crafts a special URL
 * to a specific search template to get only the tiles matching those handles.
 * =============================================================================
 */

 var RecentlyViewed = {
  view: "product-tiles",

  /**
   * Initialisation
   */
  init() {
    if(MP.Utilities.isProductPage()){
      this.storeProductView();
    }
    if(document.querySelectorAll(".section-recently-viewed").length > 0){
      this.render();
    }
  },

  /**
   * Render the panel(s)
   */
  render() {
    let handles = this.getRecentlyViewed();
    let url = this.buildFetchUrl(handles);
    this.fetchTiles(url);
  },

  /**
   * Generate a fetch URL to the /search raw view (template)
   * 
   * @param {Array} handles 
   * @returns {String} URL to fetch
   */
  buildFetchUrl(handles) {
    let prefixedHandles = handles.map(e => `handle:${e}`).join("+OR+");
    return `/search?q=${prefixedHandles}&type=product&view=${this.view}`;
  },

  /**
   * Perform a fetch from the server
   * 
   * @param {String} url 
   */
  fetchTiles(url) {
    fetch(url).then(response => response.json())
      .then(response => this.onFetchedTiles(response.tiles));
  },

  /**
   * Generate tiles for the fetched products
   * 
   * @param {Array} tiles HTML tiles returned from fetch
   */
  onFetchedTiles(tiles) {
    if(tiles.length > 0){
      document.querySelectorAll(".section-recently-viewed").forEach(e => {

        let container = e.querySelector(".recently-viewed");
        let presentation = container.dataset.presentation;
        let limit = container.dataset.limit;
        let limitedTiles = tiles.slice(0, limit);
        let tileContainer = e.querySelector("#rv-tile-container");

        switch(presentation) {
          case "stack":
            tileContainer.innerHTML = "";
            limitedTiles.forEach(tile => {
              tileContainer.insertAdjacentHTML('beforeend', `<div>${tile}</div>`);
            });
            break;
          case "carousel":
            let carousel = e.querySelector("#rv-carousel");
            let carouselSlides = carousel.querySelector(".swiper-wrapper");
            limitedTiles.forEach(tile => {
              carouselSlides.insertAdjacentHTML('beforeend', `<div class="swiper-slide"><div class="px-1">${tile}</div></div>`);
            });
            tileContainer.remove();
            carousel.classList.remove("d-none");
            break;
        }

        // Generate the necessary offcanvas elements for the tile
        e.querySelectorAll(`script[id^='offcanvas-injection--']`).forEach(e => {
          (0, eval)(e.innerText);
        });
      });
      mp_lazyload_setup();
    } else {
      document.querySelectorAll(".section-recently-viewed").forEach(e => {
        e.parentNode.removeChild(e);
      });
    }
  },

  /**
   * Get recently viewed product handles
   * 
   * @returns {Array} Handles
   */
  getRecentlyViewed() {
    return Cookies.get('rv-handles') === undefined ? [] : JSON.parse(Cookies.get('rv-handles'));
  },

  /**
   * Store the handle of the current product as a recently viewed product
   */
  storeProductView(){
    let recentlyViewedHandles = this.getRecentlyViewed();
    let currentHandle = window.location.pathname.split("/").pop();
    let hasProduct = false;

    // Don't add duplicates
    recentlyViewedHandles.forEach(handle => {
      hasProduct = handle == currentHandle || hasProduct;
    });

    if(!hasProduct){
      recentlyViewedHandles.push(currentHandle);
      if(recentlyViewedHandles.length > 30){
        recentlyViewedHandles.shift();
      }
    }

    Cookies.set('rv-handles', JSON.stringify(recentlyViewedHandles));
  }
}

export default RecentlyViewed;